<template>
  <div class="main">
    <ul id="shoufeitab">
      <li @click="tab(item)" :class="{ active: now == item }" v-for="(item, index) in lables" :key="index">
        {{ item }}
      </li>
    </ul>
    <selectTool ref="selectTool"><template slot="btn"><Button @click="getSearchItem" type="error"
          class="chaxun">查询</Button><Button @click="openAdd" type="primary" class="chaxun">新增</Button></template>
    </selectTool>

    <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)" @on-row-click="$emit('obj', $event)"
      @on-selection-change="selectData = $event">
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <Button v-if="scan" @click="$emit('objs', selectData)" type="success">我选好了</Button>
      <div>
        <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]" show-total
          show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>
    <form-model :title="isAdd ? '新增订单收费模板' : '编辑订单收费模板'" width="700" ref="formModel">
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
  </div>
</template>
<script>
var bgCosts = [{
  id: 0,
  name: '免费'
}, {
  id: 1,
  name: '按份数'
}, {
  id: 2,
  name: '按货值'
}, {
  id: 3,
  name: '一口价'
}];
var bgCosts2 = [{
  id: 3,
  name: '一口价'
}];//做动态选项
var bg = {}
for (let i = 0; i < bgCosts.length; i++) {
  bg[bgCosts[i].id] = bgCosts[i].name
}
export default {
  props: ["scan", "checkMore"],
  data() {
    return {
      isAdd: false,
      columns: [

        {
          type: "index",
          width: 70,
          align: "center",
        },

        {
          title: "操作",
          slot: "action",
          width: 130,
          scan: !this.scan,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        groupId: "",
        groupName: "",
        name: "",
        lable: "出发地费用",
        receiveAmount: 0,
        payAmount: 0,
        payCurrency: '人民币',
        sort: 1,
        remark: "",
        id: '',
        bgCost: 3,//0--免费 1--按份数，2--按货值 3--一口价
      },

      searchItem: {
        keyword: "",
        lable: '报价杂费',
        pageNumber: 1,
        pageSize: 50,
      },
      total: 0,
      categorys: [],
      forms: [
        {
          title: "收费项目",
          key: "name",
          type: "Input",
          required: true,
        },
        {
          title: "单位名称",
          key: "groupId",
          key1: "groupName",
          type: "selectGroup",
          required: true,
        },
        {
          title: "标签",
          key: "lable",
          type: "Select",
          disabled:true,
          selectItems: ['香港报关', '大陆报关', '报价杂费', '其他']
        },
        {
          title: "计费方式",
          key: "bgCost",
          key2: "bgCost2",
          type: "Select",
          selectItems: bgCosts2,
          selectType: 'obj',
          required: true,
        },

        {
          title: "应付币别",
          key: "payCurrency",
          type: "Select",
          selectItems: this.lydic.getA("mType"),
          required: true,
        },

        {
          title: "排序",
          key: "sort",
          type: "InputNumber",
        }, {
          title: "备注",
          key: "remark",
          type: "Input",
          type1: "textarea",
        },
      ],
      searchForms: [
      ],
      selectData: [],
      lables: ['报价杂费', '香港报关', '大陆报关'],
      now: '报价杂费'
    };
  },
  //http://59.37.161.185:8090/#/locate?now=1
  methods: {
    tab(item) {
      this.now = item;
      bgCosts2.length = 0;
      if (item == '大陆报关') {
        bgCosts2.push({
          id: 0,
          name: '免费'
        }, {
          id: 1,
          name: '按份数'
        });
      }
      if (item == '香港报关') {
        bgCosts2.push({
          id: 0,
          name: '免费'
        }, {
          id: 1,
          name: '按份数'
        }, {
          id: 2,
          name: '按货值'
        });
      }
      if (item == '报价杂费') {
        bgCosts2.push({
          id: 3,
          name: '一口价'
        });
      }
      this.item.bgCost = bgCosts2[0].id;
      this.getList();

    },
    getList() {
      this.searchItem.lable = this.now;
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url:
          this.axios.ipPort + "/cloud-tms-server-omc/ordersChargesTemplet/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].bgCost2 = bg[data[i].bgCost]

        }
        this.tableData = data;
        //系统默认（0-否，1-是）

      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      if (this.isAdd) {
        this.axios({
          method: "post",
          url:
            this.axios.ipPort +
            "/cloud-tms-server-omc/ordersChargesTemplet/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url:
            this.axios.ipPort +
            "/cloud-tms-server-omc/ordersChargesTemplet/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url:
              this.axios.ipPort +
              "/cloud-tms-server-omc/ordersChargesTemplet/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      for (const i in this.item) {
        this.item[i] = row[i];
      }
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.item.lable = this.now;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
  },
  mounted() {
    this.columns = this.utils.cols(this.forms, this.columns)
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 300);
  },
};
</script>
<style>
#shoufeitab {
  display: flex;
  margin-bottom: 4px;
}

#shoufeitab li {
  cursor: pointer;
  padding: 4px 10px;
  font-size: 16px;
}

#shoufeitab li.active {
  border-bottom: solid 2px #2564f8;
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/dingdan/dingdanmuban.vue